import { h } from 'vue';
import * as $icon from '@ant-design/icons-vue';

/*
 * 自动引入antd icon图标
 * */
export default {
  props: ['type'],
  setup(props) {
    var icon = '';
    if (props.type) {
      var icons = props.type.split('-');
      icons.forEach(function (value, index) {
        icon += value.slice(0, 1).toUpperCase() + value.slice(1).toLowerCase();
      });
    }
    var style = Object.assign({}, props, {
      style: {
        fontSize: "18px"
      }
    });
    return () => h($icon[icon], {
      style: style.style
    });
  }
};